import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

// Containers
const DefaultContainer = () => import(/* webpackChunkName: "main-group" */ '@/views/containers/DefaultContainer')

// Views
const Dashboard = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/Dashboard')

const Colors = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/theme/Colors')
const Typography = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/theme/Typography')

const Charts = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/Charts')
const Widgets = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/Widgets')

// Views - Components
const Cards = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/base/Cards')
const Forms = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/base/Forms')
const Switches = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/base/Switches')
const Tables = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/base/Tables')
const Tabs = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/base/Tabs')
const Breadcrumbs = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/base/Breadcrumbs')
const Carousels = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/base/Carousels')
const Collapses = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/base/Collapses')
const Jumbotrons = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/base/Jumbotrons')
const ListGroups = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/base/ListGroups')
const Navs = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/base/Navs')
const Navbars = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/base/Navbars')
const Paginations = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/base/Paginations')
const Popovers = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/base/Popovers')
const ProgressBars = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/base/ProgressBars')
const Tooltips = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/buttons/StandardButtons')
const ButtonGroups = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/buttons/ButtonGroups')
const Dropdowns = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/buttons/Dropdowns')
const BrandButtons = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/buttons/BrandButtons')

// Views - Icons
const Flags = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/icons/Flags')
const FontAwesome = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/icons/FontAwesome')
const SimpleLineIcons = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/icons/SimpleLineIcons')
const CoreUIIcons = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/icons/CoreUIIcons')

// Views - Notifications
const Alerts = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/notifications/Alerts')
const Badges = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/notifications/Badges')
const Modals = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/notifications/Modals')

// Views - Pages
const Login = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/Login')
const Page404 = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/Page404')
const Page500 = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/Page500')
const PageSessionTimeout = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/PageSessionTimeout')

// Users
const Users = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/users/Users')
const User = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/CoreUI/users/User')

//通知・発報履歴
const AlertHistory = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/AlertHistory')

// モニタリング画面
const Monitoring = () => import(/* webpackChunkName: "main-group" */ '@/views/pages/Monitoring')

// 踏切情報設定
const RailroadCrossing = () =>
  import(/* webpackChunkName: "main-group" */ '@/views/pages/RailroadCrossing')

// 検知条件設定
const DetectionArea = () =>
  import(/* webpackChunkName: "main-group" */ '@/views/pages/DetectionArea')

// ライブカメラ
const LiveCamera = () =>
  import(/* webpackChunkName: "main-group" */ '@/views/pages/LiveCamera')

// 2要素認証設定
const TwoFactorAuthentication = () =>
  import(/* webpackChunkName: "main-group" */ '@/views/pages/TwoFactorAuthentication')


const RouterContainer = {
  template: '<router-view></router-view>'
}

Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { isPrivate: false }
  },
  {
    path: '/LiveCamera',
    name: 'LiveCamera',
    component: LiveCamera,
    meta: { isPrivate: true }
  },
  {
    path: '/',
    redirect: '/alertHistory',
    name: '',
    component: DefaultContainer,
    children: [
      {
        path: 'alertHistory',
        name: '通知・発報履歴一覧',
        component: AlertHistory,
      },
    ],
  },
  {
    path: '/',
    redirect: '/monitoring',
    name: '',
    component: DefaultContainer,
    children: [
      {
        path: 'monitoring',
        name: '状態確認',
        component: Monitoring,
      },
    ],
  },
  {
    path: '/',
    redirect: '/railroadCrossing',
    name: '',
    component: DefaultContainer,
    children: [
      {
        path: 'railroadCrossing',
        name: '踏切情報設定',
        component: RailroadCrossing,
      },
    ],
  },
  {
    path: '/',
    redirect: '/detectionArea',
    name: '',
    component: DefaultContainer,
    children: [
      {
        path: 'detectionArea',
        name: '検知条件設定',
        component: DetectionArea,
      },
    ],
  },
  {
    path: '/',
    redirect: '/twoFactorAuthentication',
    name: '',
    component: DefaultContainer,
    children: [
      {
        path: 'twoFactorAuthentication',
        name: '2段階認証設定',
        component: TwoFactorAuthentication,
      },
    ],
  },
  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render (c) { return c('router-view') }
    },
    children: [
      {
        path: '404',
        name: 'Page404Sample',
        component: Page404,
        meta: { isPrivate: false }
      },
      {
        path: '500',
        name: 'Page500Sample',
        component: Page500,
        meta: { isPrivate: false }
      }
    ]
  },
  {
    path: '/session-timeout',
    name: 'SessionTimeout',
    component: PageSessionTimeout,
    meta: { isPrivate: false }
  },
  {
    path: '*',
    name: 'Page404',
    component: Page404,
    meta: { isPrivate: false }
  }
]

const router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes
})

/**
 * グローバルナビゲーションガード
 */
router.beforeEach((to, from, next) => {
  // 1. プライベートルートへのリクエスト
  //   1.1 未ログイン -> /loginへ遷移
  //   1.2 （ログイン済み、かつ、）セッションタイムアウト -> /session-timeoutへ遷移
  // 2. /loginへのリクエスト
  //   2.1. ログイン済み、かつ、セッションタイムアウトでない -> /へ遷移
  // 3. 上記以外
  //   3.1. リクエストされたルートへ遷移

  let nextPath = null
  if (to.matched.some(route => route.meta.isPrivate !== false)) {
    if (!isLoggedIn()) {
      nextPath = '/login'
    } else if (isSessionTimedOut()) {
      nextPath = '/session-timeout'
    }
  } else if (to.path === '/login') {
    if (isLoggedIn() && !isSessionTimedOut()) {
      nextPath = '/'
    }
  }

  if (nextPath) {
    next(nextPath)
  } else {
    next()
  }
})

const isLoggedIn = () => store.getters['auth/isLoggedIn']()
const isSessionTimedOut = () => store.getters['auth/isSessionTimedOut']()

export default router
